import React, { useState, useEffect, useContext } from "react";
import { RoleContext } from "../../contexts/RoleContext";
import { AuthContext } from "../../contexts/AuthContext";
import { assignRoleToUser } from "../../services/assignmentService";
import UserSelector from "../Users/UserSelector";
import Notification from "../../components/UI/Notification";

const AssignRoles = () => {
  const { token } = useContext(AuthContext); 
  const { roles, loadRoles } = useContext(RoleContext); 
  const [formData, setFormData] = useState({ id: null });
  const [selectedRole, setSelectedRole] = useState("");
  const [message, setMessage] = useState("");
  const [notification, setNotification] = useState(null);

  // Load roles when the component mounts
  useEffect(() => {
    loadRoles(token);
  }, []); 

  // new code
  const handleAssignRole = async () => {
    setMessage("");
    if (!formData.id || !selectedRole) {

      setNotification({
        message: "Please select username and role.",
        type: "error",
      });
      return;
    }

    try {
      const result = await assignRoleToUser(token, { user_id: formData.id, role: selectedRole });

      setNotification({
        message: `${result.message || "Role assigned successfully!"}`,
        type: "success",
      });
    } catch (err) {

      setNotification({
        message: `${err.message || "Failed to assign role."}`,
        type: "error",
      });
    }
  };

  return (
    // <div className="flex items-center justify-center font-poppins p-2">
    //   {notification && (
    //     <Notification message={notification.message} type={notification.type} onClose={() => setNotification(null)} />
    //   )}
    //   <div className="w-full dark:bg-gray-900 p-4">
    //     <h2 className="text-2xl font-semibold text-gray-800 mb-4 text-left dark:text-white">Assign Role to User</h2>

    //     {message && (
    //       <p
    //         className={`text-sm font-medium mb-4 ${message.includes("successfully") ? "text-green-600" : "text-red-600"
    //           }`}
    //       >
    //         {message}
    //       </p>
    //     )}

    //     <div className="mb-4">
    //       <label htmlFor="userId" className="block text-gray-700 font-medium dark:text-white mb-2">
    //         User Name: <span className="text-red-500 ml-1">*</span>
    //       </label>

    //       <UserSelector formData={formData} setFormData={setFormData} />
    //     </div>

    //     <div className="mb-4">
    //       <label htmlFor="roleSelect" className="block text-gray-700 dark:text-white font-medium mb-2">
    //         Select Role: <span className="text-red-500 ml-1">*</span>
    //       </label>
    //       <select
    //         id="roleSelect"
    //         value={selectedRole}
    //         onChange={(e) => setSelectedRole(e.target.value)}
    //         className="w-full px-4 py-2 dark:bg-black dark:text-white dark:border-gray-700 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
    //       >
    //         <option value="">Select a Role</option>
    //         {roles.map((role) => (
    //           <option key={role.id} value={role.name}>
    //             {role.name}
    //           </option>
    //         ))}
    //       </select>
    //     </div>
        
    //     <div className="flex justify-end items-center">
    //       <button
    //         onClick={handleAssignRole}
    //         className=" bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition duration-200"
    //       >
    //         Assign Role
    //       </button>
    //     </div>
    //   </div>
    // </div>

    <div className="flex items-center justify-center font-poppins p-2">
      {notification && (
        <Notification message={notification.message} type={notification.type} onClose={() => setNotification(null)} />
      )}
      <div className="w-full dark:bg-gray-900 p-4">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4 text-left dark:text-white">Assign Role to User</h2>
        {message && (
          <p
            className={`text-sm font-medium mb-4 ${message.includes("successfully") ? "text-green-600" : "text-red-600"
            }`}
          >
            {message}
          </p>
        )}
        <div className="flex flex-wrap gap-4 items-end">
          <div className="flex-1 min-w-[200px]">
            <label htmlFor="userId" className="block text-gray-700 font-medium dark:text-white mb-2">
              User Name: <span className="text-red-500 ml-1">*</span>
            </label>
            <UserSelector formData={formData} setFormData={setFormData} />
          </div>
          <div className="flex-1 min-w-[200px]">
            <label htmlFor="roleSelect" className="block text-gray-700 dark:text-white font-medium mb-2">
              Select Role: <span className="text-red-500 ml-1">*</span>
            </label>
            <select
              id="roleSelect"
              value={selectedRole}
              onChange={(e) => setSelectedRole(e.target.value)}
              className="w-full px-4 py-2 dark:bg-black dark:text-white dark:border-gray-700 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="">Select a Role</option>
              {roles.map((role) => (
                <option key={role.id} value={role.name}>
                  {role.name}
                </option>
              ))}
            </select>
          </div>
          <div className="flex-shrink-0">
            <button
              onClick={handleAssignRole}
              className="bg-blue-600 text-white px-4 font-medium py-2 rounded-lg hover:bg-blue-700 transition duration-200"
            >
              Assign Role
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssignRoles;
